import React, { useState } from 'react'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  ListItemButton,
  ListItemText,
  List as MuiList,
} from '@mui/material'
import { useCustomer } from 'features/customers/hooks/useCustomer'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { useCustomerUserUpsert } from 'features/customers/hooks/useCustomerUserUpsert'
import { isPlgPlan, isSlgPlan } from 'features/customers/utils/customers'

import { reduceIntoList } from '@albacross/frontend-utils'
import { EPermissions } from '@albacross/types'

import { useUsers } from 'hooks/useUsers'
import debounceEventHandler from 'utils/debounceEventHandler'

type AddCustomerUserProps = {
  open: boolean
  onClose: (...args: any[]) => any
}

const AddCustomerUser = ({ open, onClose }: AddCustomerUserProps) => {
  const [userId, setUserId] = useState<number | null>(null)
  const [search, setSearch] = useState('')

  const customerId = useCustomerId()
  const { data: customer } = useCustomer(customerId)
  const { data } = useUsers({ filters: { search } })
  const { mutateAsync: addCustomerUser } = useCustomerUserUpsert()

  const users = reduceIntoList(data?.items, x => x)

  const handleSearchChange = event => setSearch(event.target.value)
  const handleAdd = async () => {
    if (!userId) return

    if (isPlgPlan(customer?.plan?.name) || isSlgPlan(customer?.plan?.name)) {
      await addCustomerUser({
        userId,
      })
    } else {
      await addCustomerUser({
        userId,
        permissions: {
          [EPermissions.OutreachSender]: false,
        },
      })
    }

    onClose()
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>
        <Box sx={{ display: 'flex' }}>
          Add user
          <Input
            onChange={debounceEventHandler(handleSearchChange, 300)}
            placeholder="Search..."
            sx={{ ml: 'auto', fontWeight: 400 }}
          />
        </Box>
      </DialogTitle>

      <DialogContent style={{ width: 500 }}>
        <MuiList>
          {users.map((user, index) => (
            <ListItemButton key={index} onClick={() => setUserId(user.id)} selected={user.id === userId}>
              <ListItemText primary={`${user.first_name} ${user.last_name}`} secondary={user.email} />
            </ListItemButton>
          ))}
        </MuiList>
      </DialogContent>
      <DialogActions>
        <Button disabled={!userId} onClick={handleAdd}>
          Add user
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddCustomerUser
